import React from "react";
import { useTranslation } from "react-i18next";

import { CreateLocalPostButton } from "../../../../containers/LocalPostsPage/CreateLocalPostButton";
import { LocationData } from "../../../../models/LocationData";
import { SuggestedLocalPostData } from "../../../../models/SuggestedLocalPostData";
import "./styles.scss";

export interface ISuggestedLocalPostItemProps {
  postItem: SuggestedLocalPostData;
  locationData?: LocationData;
}

export const SuggestedLocalPostItem: React.FunctionComponent<
  ISuggestedLocalPostItemProps
> = ({ postItem, locationData }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.keywordAnalysis.${key}`);

  return (
    <div className="suggested-local-post-item">
      <div className="suggested-local-post-top-info">
        <div className="left-title">{postItem.location.name}</div>
        <div className="right-title">
          {new Date(postItem.created_at).toLocaleDateString()}
        </div>
      </div>

      <div className="suggested-local-post-bottom-container">
        <div className="suggested-local-post-img-container">
          <div className="image-description-header"></div>
          {postItem.image_description ? (
            <div className="image-description-text">
              {postItem.image_description}
            </div>
          ) : (
            <div className="no-image-text">{t("noImageDescription")}</div>
          )}
        </div>

        {postItem.summary ? (
          <div className="summary">{postItem.summary}</div>
        ) : (
          <div className="no-summary">{t("noSummary")}</div>
        )}
      </div>

      <div className="post-button-container">
        {locationData && (
          <CreateLocalPostButton
            locationData={locationData}
            suggestedLocalPost={postItem}
            buttonText={t("post")}
          />
        )}
      </div>
    </div>
  );
};
